import { isDOM } from '@app/shared/predicates'
import type WallClockTimeTracker from '../services/wall-clock-time-tracker'

import setupWallClockTimeTracker from './setup-wall-clock-time'

let tracker: WallClockTimeTracker | null = null

window.onDomLoad(function ($dom) {
  if (!isDOM($dom[0])) {
    return
  }

  if (tracker) {
    tracker.sendAccumulatedTime()
    tracker.teardown()
  }

  tracker = setupWallClockTimeTracker($dom[0])
})
